import { render, staticRenderFns } from "./admin-report-dialog.vue?vue&type=template&id=5f07ad17&scoped=true&"
import script from "./admin-report-dialog.vue?vue&type=script&lang=js&"
export * from "./admin-report-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07ad17",
  null
  
)

export default component.exports